export default "__VITE_ASSET__$Vyojs3y__"